import React from 'react';
import './DownloadLinkRow.css';

export function DownloadLinkRow({ link, onDownload, isLoading = false, isLocked = false }) {
  if (!link || !link.url || !link.name) return null;

  const isDownload = link.type === 'download';
  const icon = isLocked ? 'fa-lock' : isDownload ? 'fa-download' : 'fa-external-link-alt';

  const handleClick = () => {
    if (isLoading) {
      return;
    }

    if (onDownload) {
      onDownload(link);
    } else {
      // Fallback to direct opening if no callback provided
      window.open(link.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className={`download-link-row ${isLoading ? 'download-link-row--loading' : ''} ${isLocked ? 'download-link-row--locked' : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={isLoading ? -1 : 0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      aria-disabled={isLoading}
    >
      <div className="download-link-row-info">
        <i className={`fa-solid ${isLoading ? 'fa-spinner fa-spin' : icon}`} aria-hidden></i>
        <span className="download-link-row-name">{link.name}</span>
      </div>
      {link.size && (
        <span className="download-link-row-size">{link.size}</span>
      )}
    </div>
  );
}
